export default __webpack_public_path__ + "static/media/loading.c98f7bd0.svg";